import React, { useContext } from "react";

/**
 * Intent types
 * extends blueprints js intent
 */
export const Intent = {
		NONE: "none",
		PRIMARY: "primary",
		SUCCESS: "success",
		WARNING: "warning",
		DANGER: "danger",
		LOADING: "loading"
};

export declare type Intent = typeof Intent[keyof typeof Intent];

export interface IIntentContext {
	intent: Intent;
	setBy: string;
}

// IntentContext
const IntentContext = React.createContext<IIntentContext>({} as any);
export default IntentContext;

export const IntentProvider: React.SFC<{intent: Intent | ""}> = ({children, intent}) => {
	const context = useContext(IntentContext);

	const value = intent ? {...context, intent} : context;

	return (
		<IntentContext.Provider value={value}>
			{children}
		</IntentContext.Provider>
	);
};



// WEBPACK FOOTER //
// ./src/core/components/IntentContext.tsx